import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5161b4ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "faq__top-info" }
const _hoisted_3 = { class: "sm:flex sm:space-x-2" }
const _hoisted_4 = { class: "faq__actions" }
const _hoisted_5 = { class: "faq__views" }
const _hoisted_6 = { class: "faq__title flex" }
const _hoisted_7 = {
  key: 0,
  class: "visibility bg-red-100 text-red-800 text-xs font-medium mr-2 px-2-5 py-0-5 rounded dark:bg-gray-700 dark:text-red-400 border border-red-400 self-center"
}
const _hoisted_8 = { class: "faq__info" }
const _hoisted_9 = {
  key: 0,
  class: "faq__created"
}
const _hoisted_10 = ["data-tooltip"]
const _hoisted_11 = {
  key: 1,
  class: "faq__updated"
}
const _hoisted_12 = ["data-tooltip"]
const _hoisted_13 = { class: "faq__actions mobile-only" }
const _hoisted_14 = { class: "confirm-alert" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Er du sikker?", -1))
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "italic" }
const _hoisted_18 = { class: "confirm-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messages = _resolveComponent("Messages")!
  const _component_CategoryPill = _resolveComponent("CategoryPill")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Link = _resolveComponent("Link")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_MarkdownContent = _resolveComponent("MarkdownContent")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "faq" }, {
      default: _withCtx(() => [
        _createVNode(_component_Messages, { class: "attribute-index-messages" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_CategoryPill, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.faq.category?.breadcrumbs), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Link, {
              class: "faq__edit-button",
              href: _ctx.route('faq.edit', { faq: _ctx.faq.id })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconButton, {
                  color: "gray",
                  class: "edit-button tooltip",
                  "data-tooltip": "Rediger",
                  path: _ctx.editIcon
                }, null, 8, ["path"])
              ]),
              _: 1
            }, 8, ["href"]),
            _createVNode(_component_IconButton, {
              color: "gray",
              class: "slett-button tooltip",
              "data-tooltip": "Slett",
              path: _ctx.mdiTrashCan,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteOpen = true))
            }, null, 8, ["path"])
          ])
        ]),
        _createElementVNode("p", _hoisted_5, [
          _createVNode(_component_SvgIcon, {
            size: 24,
            type: "mdi",
            path: _ctx.eyeIcon
          }, null, 8, ["path"]),
          _createTextVNode(" " + _toDisplayString(_ctx.faq.views), 1)
        ]),
        _createElementVNode("h1", _hoisted_6, [
          (_ctx.faq.is_draft == '1')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Utkast"))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.faq.title), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.faq.created_by)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                _createTextVNode(" Opprettet "),
                _createElementVNode("span", {
                  class: "tooltip tooltip--indicated",
                  "data-tooltip": _ctx.createdAbsoluteDate
                }, _toDisplayString(_ctx.createdRelativeDate), 9, _hoisted_10),
                _createTextVNode(" av " + _toDisplayString(_ctx.faq.created_by.firstname + " " +  _ctx.faq.created_by.lastname), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.faq.updated_by)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                _createTextVNode(" Sist oppdatert "),
                _createElementVNode("span", {
                  class: "tooltip tooltip--indicated",
                  "data-tooltip": _ctx.updatedAbsoluteDate
                }, _toDisplayString(_ctx.updatedRelativeDate), 9, _hoisted_12),
                _createTextVNode(" av " + _toDisplayString(_ctx.faq.created_by.firstname + " " +  _ctx.faq.created_by.lastname), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_MarkdownContent, {
            class: "faq__description",
            content: _ctx.faq.description
          }, null, 8, ["content"])
        ])
      ]),
      _: 1
    }),
    (_ctx.deleteOpen)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          "with-card": "",
          onDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteOpen = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("p", _hoisted_16, [
                _createTextVNode("Er du sikker på at du vil slette FAQen "),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.faq.title), 1),
                _createTextVNode(" ?")
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_Button, {
                  color: "red",
                  onClick: _ctx.deleteFaq,
                  disabled: _ctx.deleteLoading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      class: _normalizeClass(["mr-1", {
            'animate-spin': _ctx.deleteLoading,
          }]),
                      type: "mdi",
                      path: _ctx.deleteLoading ? _ctx.mdiLoading : _ctx.mdiTrashCan
                    }, null, 8, ["path", "class"]),
                    _createTextVNode(" Slett ")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_Button, {
                  color: "gray",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteOpen = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avbryt")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}